import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuItem from './menuItem'
import MenuTree from './menuTree'
import { withRouter } from 'react-router-dom';

import { carregarUsuario } from '../../auth/authActions';

class Menu extends Component {

	state = {
		acessoAberto: null,
		cadastroAberto: null
	}

	constructor(props) {
		super(props);

		let idInterval = setInterval(() => {
			if (this.props.usuario) {
				this.props.carregarUsuario();
				clearInterval(idInterval);
			}
		}, 2000);
	}

	render() {

		const usuarioCarregado = this.props.usuarioCarregado;

		let selecionado = '';
		if (this.props.location && this.props.location.pathname) {
			selecionado = this.props.location.pathname;
		}

		if (selecionado != '/' && this.state.acessoAberto == null && this.state.cadastroAberto == null
			&& this.state.precoAberto == null && this.state.vendaAberto == null 
			&& this.state.logisticaAberto == null && this.state.metaMotoristaAberto == null 
			&& this.state.metaVendedorAberto == null) {
			if (selecionado == '/usuarioPerfil' || selecionado == '/usuario') {
				this.setState({
					...this.state,
					acessoAberto: true
				});
			}
			
			if (selecionado == '/departamento' || selecionado == '/grupoCliente' || selecionado == '/cliente' 
				|| selecionado == '/equipamento' || selecionado == '/checklist' || selecionado == '/modeloRelatorio'
			 	|| selecionado == '/certificadoModelo') {
				this.setState({
					...this.state,
					cadastroAberto: true
				});
			}
		}
		
		return (
			<nav className="mt-2">

				{usuarioCarregado &&								    
				<ul className="nav nav-pills nav-sidebar flex-column nav-flat nav-compact" data-widget="treeview" role="menu" data-accordion="false">
					{usuarioCarregado.acesso_dashboard &&
					<MenuItem path='/' label='Dashboard' icon='fas fa-tachometer-alt' active={selecionado == '/'} />}
					
					{usuarioCarregado.acesso_cadastro_usuario &&
					<MenuTree icon={'fas fa-user-lock'} label={'Acesso'}
						display={this.state.acessoAberto}
						onClick={() =>
							this.setState({
								...this.state,
								acessoAberto: !this.state.acessoAberto,
							})
						} >
						<MenuItem submenu path='usuarioPerfil' label='Perfil de Usuário' icon='fas fa-user-tag' active={selecionado == '/usuarioPerfil'} />
						<MenuItem submenu path='usuario' label='Usuário' icon='fas fa-id-card-alt' active={selecionado == '/usuario'} />
					</MenuTree>}

					{(
						usuarioCarregado.acesso_cadastro_departamento
						|| usuarioCarregado.acesso_cadastro_cliente
						|| usuarioCarregado.acesso_cadastro_checklist
						|| usuarioCarregado.acesso_cadastro_modelo_relatorio 
						|| usuarioCarregado.acesso_cadastro_modelo_certificado
					) &&
					<MenuTree icon={'fas fa-cog'} label={'Cadastro'}
						display={this.state.cadastroAberto}
						onClick={() =>
							this.setState({
								...this.state,
								cadastroAberto: !this.state.cadastroAberto,
							})
						} >
						{usuarioCarregado.acesso_cadastro_departamento &&
						<MenuItem submenu path='departamento' label='Departamento' icon='fas fa-building' active={selecionado == '/departamento'} />}

						{usuarioCarregado.acesso_cadastro_cliente &&
						<MenuItem submenu path='grupoCliente' label='Região / Grupo' icon='fas fa-users' active={selecionado == '/grupoCliente'} />}
						{usuarioCarregado.acesso_cadastro_cliente &&
						<MenuItem submenu path='cliente' label='Cliente' icon='fas fa-user-edit' active={selecionado == '/cliente'} />}
						{/*usuarioCarregado.acesso_cadastro_cliente &&
						<MenuItem submenu path='equipamento' label='Equipamento' icon='fas fa-warehouse' active={selecionado == '/equipamento'} />*/}
						{usuarioCarregado.acesso_cadastro_checklist &&
						<MenuItem submenu path='checklist' label='Checklist' icon='fas fa-clipboard-check' active={selecionado == '/checklist'}
							onClick={() => {							
								if (selecionado == '/checklist') {
									window.location.reload();
								}
							}} />}
						{usuarioCarregado.acesso_cadastro_modelo_relatorio &&
						<MenuItem submenu path='modeloRelatorio' label='Modelo de Relatório' icon='fas fa-file' active={selecionado == '/modeloRelatorio'} />}
						{usuarioCarregado.acesso_cadastro_modelo_certificado &&
						<MenuItem submenu path='certificadoModelo' label='Modelo de Certificado' icon='fas fa-certificate' active={selecionado == '/certificadoModelo'} />}
					</MenuTree>}

					{(usuarioCarregado.acesso_checklist_resposta_admin || usuarioCarregado.acesso_checklist_resposta) &&
					<MenuItem path='checklistResposta' label='Agendamentos' icon='fas fa-clipboard' active={selecionado == '/checklistResposta'} 
						onClick={() => {							
							if (selecionado == '/checklistResposta') {
								window.location.reload();
							}
						}} />}

					{usuarioCarregado.acesso_relatorio &&
					<MenuItem path='relatorio' label='Relatórios' icon='fas fa-file-invoice' active={selecionado == '/relatorio'} />}

					{usuarioCarregado.acesso_emitir_certificado &&
					<MenuItem path='certificadoEmissao' label='Certificados' icon='fas fa-certificate' active={selecionado == '/certificadoEmissao'} />}
				</ul>}
			</nav>
		);
	}
}

const mapStateToProps = state => ({
	usuario: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado
});
const mapDispatchToProps = dispatch => bindActionCreators({ carregarUsuario }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
